import React, { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Header from './Header'
import Footer from './Footer'
import AnnouncementBanner from './AnnouncementBanner'
import ScrollToTop from './ScrollToTop'
import useLocalePath from '../i18n/useLocalePath'

export default function Layout() {
  const { pathname } = useLocation()
  const { i18n } = useTranslation()
  const { isSpanish } = useLocalePath()

  /* The URL decides the language: /es/... is Spanish and everything else is
     English, regardless of a stored preference. Otherwise a visitor who once
     picked Spanish would get Spanish copy on English URLs (and English
     canonicals), and blog posts would look up the wrong language's slug. */
  useEffect(() => {
    const lang = isSpanish ? 'es' : 'en'
    if (!i18n.language.startsWith(lang)) {
      i18n.changeLanguage(lang)
    }
  }, [isSpanish, i18n])

  /* strip the /es prefix so page checks work in both language trees */
  const basePath = isSpanish ? (pathname.replace(/^\/es/, '') || '/') : pathname

  const isHome = basePath === '/'

  const whiteBgPrefixes = [
    '/terms-of-service',
    '/privacy-policy',
    '/faq',
    '/download',
    '/delete-account',
    '/data-deletion',
    '/about',
    '/blog',
  ]
  const isWhiteBg = whiteBgPrefixes.some(prefix =>
    basePath.startsWith(prefix)
  )

  const mainBg   = isWhiteBg ? 'bg-white' : 'bg-brand'
  const mainFlex = isHome ? '' : 'flex-grow'

  return (
    <div className="flex flex-col min-h-screen text-gray-900">
      <ScrollToTop />
      <AnnouncementBanner />
      <Header />
      <main className={`${mainFlex} ${mainBg}`}>
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
